module.exports = __webpack_public_path__ + "img/ben-kw-02.e987868c.jpg";